var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5V2a1 1 0 012 0v3a1 1 0 01-2 0zm1 3a8 8 0 108 8 8.009 8.009 0 00-8-8zm-8.707.707a1 1 0 101.414-1.415l-2-2a1 1 0 10-1.414 1.415l2 2zm0 14.585l-2 2a1 1 0 101.414 1.415l2-2a1 1 0 10-1.415-1.415zM24 9a1 1 0 00.707-.293l2-2a1 1 0 00-1.415-1.414l-2 2A1 1 0 0024 9zm.707 14.293a1 1 0 10-1.415 1.415l2 2a1 1 0 001.415-1.415l-2-2zM6 16a1 1 0 00-1-1H2a1 1 0 000 2h3a1 1 0 001-1zm10 10a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm14-11h-3a1 1 0 000 2h3a1 1 0 000-2z"
  })));
}
export default SvgSunFill;